<template>
    <div v-if="data" class="sustainability-idea">
        <headline :title="data.title"></headline>
        <div class="idea-video" v-if="data.video">
            <resourceVideoVue
                :options="{ source: data.video }"
                :title="title"
            ></resourceVideoVue>
        </div>
        <div v-else-if="data.img" class="idea-img">
            <img v-src="data.img" alt="" />
        </div>
        <div class="desc-box">
            <headline
                class="desc-title"
                :title="data.descTitle"
            ></headline>
            <RichText v-if="data.desc" :data="data.desc"></RichText>
        </div>
    </div>
</template>
<script>
import { getDataHierarchy } from '@custouch/proxy-use'
import headline from './components/headline.vue'
import RichText from '@/views/components/RichText.vue'
import { Toast } from 'vant'
import resourceVideoVue from '@/views/components/resourceVideo.vue'
export default {
    name: 'Idea',
    props: ['hId', 'title'],
    data() {
        return {
            data: {}
        }
    },
    components: { headline, RichText, resourceVideoVue },
    async created() {
        const loadingToast = Toast.loading()
        const ret = await getDataHierarchy({
            dataHierarchyId: this.hId
        })
        this.data = ret.detail
        loadingToast.clear()
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/mixin.less';
.sustainability-idea {
    padding: @padding-lg 0;
    .idea-video{
        margin: @padding-md 0;
    }
    .idea-img {
        width: 100%;
        height: 9.65rem;
        margin: @padding-md 0;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: @border-radius-sm + @border-radius-md;
        }
    }
}
</style>
<style lang="less">
.sustainability-idea {
    .idea-desc {
        img {
            height: auto;
        }
    }
    .desc-box{
        img{
            width: auto !important;
            height: auto !important;
            object-fit: contain !important;
        }
    }
}
</style>
